import { formatDateOnly } from './eightDReportUtils';

export const EIGHT_D_LIST_EXPORT_COLUMNS = [
    { key: 'reportNo', label: 'Report ID' },
    { key: 'originSource', label: 'Origin / Source' },
    { key: 'dateOpened', label: 'Date Opened' },
    { key: 'problemDescription', label: 'Problem Description' },
    { key: 'ownerName', label: 'Assigned Owner' },
    { key: 'targetDate', label: 'Target Date' },
    { key: 'dateClosed', label: 'Date Closed' },
    { key: 'displayStatus', label: 'Status' },
];

function rowToExportObject(row) {
    const obj = {};
    EIGHT_D_LIST_EXPORT_COLUMNS.forEach(({ key, label }) => {
        let val = row[key];
        if (key === 'dateOpened' || key === 'targetDate' || key === 'dateClosed') {
            val = formatDateOnly(val);
        }
        obj[label] = val != null ? val : '';
    });
    return obj;
}

export async function exportEightDListToExcel(rows, summary) {
    try {
        const XLSX = await import('xlsx').catch(() => null);
        if (!XLSX) {
            window.alert("Excel export requires the 'xlsx' package.");
            return;
        }
        const data = (rows || []).map(rowToExportObject);
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '8D Summary');

        if (summary) {
            const summarySheet = XLSX.utils.aoa_to_sheet([
                ['TOTAL 8Ds', summary.total ?? ''],
                ['OPEN', summary.open ?? ''],
                ['IN PROGRESS', summary.inProgress ?? ''],
                ['CLOSED', summary.closed ?? ''],
                ['OVERDUE', summary.overdue ?? ''],
            ]);
            XLSX.utils.book_append_sheet(wb, summarySheet, 'Summary counts');
        }

        const stamp = new Date().toISOString().slice(0, 10);
        XLSX.writeFile(wb, `8D-Summary-List-${stamp}.xlsx`);
    } catch (err) {
        console.error('8D export error:', err);
        window.alert('Export failed. Please try again.');
    }
}
